const removeItemfromArray = (array, element) => {
    const index = array.indexOf(element)
    
    if(-1 !== index) {
        array.splice(index, 1)

        return array
    } else {
        return false
    }
}

export default removeItemfromArray